import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, ShoppingBag, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import ContactModal from '../components/ContactModal';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_91be65d6-9fee-4eda-abde-3fd83cab62ae/artifacts/kxr3j7eu_IMG_7793.png";

export default function NotFound() {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      {/* Header */}
      <header className="border-b border-zinc-800 bg-[#050505]/95 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="BLK MRKT" className="h-8 w-auto" />
          </Link>
          <Link to="/" className="p-2 text-zinc-400 hover:text-tiffany-500 transition-colors">
            <Home className="w-5 h-5" />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          {/* 404 Number */}
          <div className="mb-6">
            <span className="font-mono text-8xl sm:text-9xl font-bold text-zinc-800 select-none">
              404
            </span>
          </div>

          {/* Message */}
          <h1 className="font-sans text-2xl sm:text-3xl text-white mb-4 tracking-wide">
            THIS ITEM HAS LEFT THE CATALOG
          </h1>
          
          <p className="font-mono text-sm text-zinc-500 mb-8 leading-relaxed">
            THE PAGE YOU'RE LOOKING FOR DOESN'T EXIST OR HAS BEEN MOVED.
            <br />
            IT MAY HAVE BEEN SOLD OR REMOVED FROM THE DROP.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              asChild
              className="h-12 px-8 bg-tiffany-500 text-black hover:bg-tiffany-400 font-mono text-sm rounded-none"
            >
              <Link to="/catalog">
                <ShoppingBag className="w-4 h-4 mr-2" />
                BACK TO CATALOG
              </Link>
            </Button>
            
            <Button
              asChild
              variant="outline"
              className="h-12 px-8 border-zinc-700 text-zinc-300 hover:bg-zinc-800 hover:text-white font-mono text-sm rounded-none"
            >
              <Link to="/">
                <ArrowLeft className="w-4 h-4 mr-2" />
                GO HOME
              </Link>
            </Button>
          </div>

          {/* Decorative Element */}
          <div className="mt-12 flex justify-center gap-2">
            <div className="w-2 h-2 bg-zinc-800 rounded-full"></div>
            <div className="w-2 h-2 bg-tiffany-500 rounded-full"></div>
            <div className="w-2 h-2 bg-zinc-800 rounded-full"></div>
          </div>
        </div>
      </main>

      {/* Footer hint */}
      <footer className="py-6 text-center">
        <p className="font-mono text-xs text-zinc-600">
          NEED HELP?{' '}
          <button 
            onClick={() => setShowContactModal(true)}
            className="text-tiffany-500 hover:underline"
          >
            CONTACT SUPPORT
          </button>
        </p>
      </footer>

      {/* Contact Modal */}
      <ContactModal 
        isOpen={showContactModal} 
        onClose={() => setShowContactModal(false)}
        defaultSubject="404 Error"
      />
    </div>
  );
}
